import { Layout } from 'antd';
/*

Blank Layout - Wrap for printing

*/
import React from "react";

export default function Blank(props) {
    const {bg_color = "#f0f2f5"} = props; 
    return (
        <>  
            <Layout style={{"backgroundColor" : (bg_color) ? bg_color : ""}}>
                <Layout.Content className="bcg bc" style={{"min-height": "100vh", "overflow": "auto", "backgroundColor" : (bg_color) ? bg_color : "" }}>
                    <div style={{ "padding": "0px"}}>
                        {props.children}
                    </div>
                </Layout.Content>
            </Layout>
        </>
    );

}